import { render, staticRenderFns } from "./invoice-full-details-lines.vue?vue&type=template&id=cffe9f22&scoped=true&"
import script from "./invoice-full-details-lines.vue?vue&type=script&lang=ts&"
export * from "./invoice-full-details-lines.vue?vue&type=script&lang=ts&"
import style0 from "./invoice-full-details-lines.vue?vue&type=style&index=0&id=cffe9f22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cffe9f22",
  null
  
)

export default component.exports